import { WOW } from 'wowjs';

(function ($) {
    function completed(el) {
        el.addEventListener('animationend', () => {
            $(el).addClass('animation-done');
        });
    }

    setTimeout(() => {
        new WOW({
            boxClass: 'wowEffect',
            mobile: true,
            callback: completed,
        }).init(); 
    }, 0);
}(jQuery))
